import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'pedido en mesa',
    [ORDER_METHODS.PICKUP]: 'recogida',
    [ORDER_METHODS.DELIVERY]: 'entrega',
  },
  errors: {
    draft_validation_failed: 'Por favor, completa tu dirección de entrega antes de continuar.',
  },
};
